export default __webpack_public_path__ + "static/media/paymendo-logo.8439eebb.png";